'use client';
import React, {
  Suspense,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import dynamic from 'next/dynamic';
import { useMemo, useCallback } from 'react';
import Image from 'next/image';
import CategoryItems from './product-page-widgets/CategoryItems';
import DropdownMenu from '@/components/widgets/DropdownMenu';
const ProductGridWithGifs = dynamic(
  () => import('@/components/widgets/ProductGridWithGifs')
);
import SustainableLuxury from '../home-page/home-page-widgets/SustainableLuxury';
import { useProductsByParam } from '@/hooks/useProducts';
const ProductGrid = dynamic(
  () => import('./product-page-widgets/ProductGridDynamic')
);

import { useRouter, useSearchParams } from 'next/navigation';
import { FetchProductParams } from '@/helpers/types/params_body/FetchProductParams';
import SimpleComponent from '@/components/widgets/SimpleComponent';
import Loading from '@/components/widgets/Loading';
import { useUser } from '@/components/widgets/UserProvider';
import Footer from '@/components/widgets/footer/Footer';
import ScrollFade from '@/components/widgets/ScrollFade';
import FilterDrawer from '@/components/widgets/FilterDrawer';

const ProductListingPage: React.FC = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [isOpen, setIsOpen] = useState(false);
  const [skip, setSkip] = useState(0);
  const [page, setPage] = useState(1);

  const pageRef = useRef<HTMLDivElement>(null);
  const karatPriority = ["10", "14", "18"];
  const [activeKarat, setActiveKarat] = useState(karatPriority[0]);
  const mainCategory = searchParams.get('main_category');
  const metalInfo = searchParams.get('metal_info');
  const subcategory = searchParams.get('subcategory');

  const sortBy = searchParams.get('sort_by') as
    | 'low_to_high'
    | 'high_to_low'
    | 'new_to_old'
    | 'old_to_new'
    | 'a_to_z'
    | 'z_to_a'
    | null;

  const color = searchParams.get('color');
  const shape = searchParams.get('shape');
  const stock = searchParams.get('stock');
  const stoneType = searchParams.get('stoneType');
  const karat = searchParams.get('karat');
  const priceRange = searchParams.get('priceRange');
  const priceRangeType = searchParams.get('priceRangeType') as
    | 'under'
    | 'between'
    | 'above'
    | null;

  const params: FetchProductParams = {
    main_category: mainCategory,
    metal_info: metalInfo,
    // subcategory: subcategory === 'Studs' ? 'VSER' : subcategory,
    subcategory:subcategory,
    sort_by: sortBy,
    color,
    shape,
    stock,
    stoneType,
    karat:activeKarat,
    priceRange,
    priceRangeType,
    page: page,
    limit: 16,
  };

  useEffect(() => {
    setSkip(0);
    setPage(1);
    scrollToTop();
    setActiveKarat(karatPriority[0])
  }, [
    mainCategory,
    metalInfo,
    subcategory,
    sortBy,
    color,
    shape,
    stock,
    stoneType,
    karat,
    priceRange,
    priceRangeType,
  ]);


  const { products, isLoading, isError, pagination } =
    useProductsByParam(params);


  useEffect(() => {
      if (!isLoading && (!products || products.length === 0)) {
        console.log('cbdsfayf',activeKarat);

        const currentIndex = karatPriority.indexOf(activeKarat);
        if (currentIndex < karatPriority.length - 1) {
          setActiveKarat(karatPriority[currentIndex + 1]);
        }
      }
  }, [products, isLoading, activeKarat]);
  const { userPageLoading } = useUser();

  const handleFilterClick = useCallback((item: string) => {
    //console.log('Filter item clicked:', item);
  }, []);

  const handleSortByClick = (item: string) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set('sort_by', item);
    router.push(`/product-listing?${params.toString()}`);
  };

  const ringsCategory = [
    {
      name: 'Solitaire',
      main_category:'Rings',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/All%20compressed%20assets/Vertelier%20Compressed%20Files/VERI%20Compressed/VERI1005RD/w1.webp',
      redirect: '/product-listing?subcategory=Solitaire&main_category=Rings',
    },
    {
      name: 'Halo',
      main_category:'Rings',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0081/w1.png',
      redirect: '/product-listing?subcategory=Halo%20Ring',
    },
    // {
    //   name: 'Toi Et moi',
    //   image:
    //     'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0517/W1.png',
    //   redirect: '/product-listing?subcategory=Toi-et-Moi',
    // },
    {
      name: 'Three Stone',
      main_category:'Rings',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0625/w1.png',
      redirect: '/product-listing?subcategory=Three%20Stone',
    },
    {
      name: 'Secret Halo',
      main_category:'Rings',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0081/w1.png',
      redirect: '/product-listing?subcategory=Hidden%20Halo%20Ring',
    },
    {
      name: 'Bezel',
      main_category:'Rings',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0508/w1.png',
      redirect: '/product-listing?subcategory=Bezel',
    },
    {
      name: 'Nature Inspired',
      main_category:'Rings',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0695/w1.png',
      redirect: '/product-listing?subcategory=Nature%20Inspired',
    },
    {
      name: 'Designer',
      main_category:'Rings',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0695/w1.png',
      redirect: '/product-listing?subcategory=Designer&main_category=Rings',
    },
  ];

  const threeStoneRingsCategory = [
    {
      name: 'Solitaire',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI1005RD/w1.png',
      redirect: '/product-listing?subcategory=Solitaire&main_category=Rings',
    },
    {
      name: 'Halo',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0081/w1.png',
      redirect: '/product-listing?subcategory=Halo%20Ring',
    },

    {
      name: 'Secret Halo',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0081/w1.png',
      redirect: '/product-listing?subcategory=Hidden%20Halo%20Ring',
    },
    // {
    //   name: 'Toi Et moi',
    //   image:
    //     'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0517/W1.png',
    //   redirect: '/product-listing?subcategory=Toi-et-Moi',
    // },
    {
      name: 'Three Stone',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0625/w1.png',
      redirect: '/product-listing?subcategory=Three%20Stone',
    },
    // {
    //   name: 'Bezel',
    //   image:
    //     'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0508/w1.png',
    //   redirect: '/product-listing?subcategory=Bezel',
    // },
    {
      name: 'Nature Inspired',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0695/w1.png',
      redirect: '/product-listing?subcategory=Nature%20Inspired',
    },
    // {
    //   name: 'Designer',
    //   image:
    //     'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0695/w1.png',
    //   redirect: '/product-listing?subcategory=Designer',
    // },
  ];

  const earringsCategory = [
    {
      name: 'Studs',
      main_category:'Earring',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VDER0301/w1.png',
      redirect: '/product-listing?subcategory=Studs&main_category=Earring',
    },
    {
      name: 'Hoops',
      main_category:'Earring',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VDER0308/w1.png',
      redirect: '/product-listing?subcategory=Hoops',
    },
    {
      name: 'Designer',
      main_category:'Earring',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VDER0304/w1.png',
      redirect: '/product-listing?subcategory=Designer&main_category=Earring',
    },
    {
      name:'Three Stone',
      main_category:'Earring',
      image: 'https://vert-test-assets.nyc3.digitaloceanspaces.com/website/All%20compressed%20assets/Vertelier%20Compressed%20Files/Mega%20compress/READY/VSPL/VSPL0025/Y1.webp',
      redirect:'/product-listing?subcategory=Three Stone&main_category=Earring'
    },
    {
      name:'Solitaire',
      main_category:'Earring',
      image:'https://vert-test-assets.nyc3.digitaloceanspaces.com/website/All compressed assets/Vertelier Compressed Files/Mega compress/READY/VSER0001/y1.webp',
      redirect:'/product-listing?subcategory=Solitaire&main_category=Earring'
    },
    {
      name:'Instock',
      main_category:'Earring',
      image:'https://vert-test-assets.nyc3.digitaloceanspaces.com/website/VINS/VINS/Uploads/VINS0006/r1',
      redirect:'/product-listing?subcategory=Instock&main_category=Earring'
    }
  ];

  const necklaceCategory = [
    {
      name: 'Tennis',
      main_category :'Necklace',
      image:
        'https://vert-test-assets.nyc3.digitaloceanspaces.com/website/All%20compressed%20assets/Vertelier%20Compressed%20Files/Mega%20compress/READY/VSPL/VSPL0004/Y1.webp',
      redirect: '/product-listing?subcategory=Tennis&main_category=Necklace',
    },
    {
      name: 'Designer',
      main_category :'Necklace',
      image: 'https://vert-test-assets.nyc3.digitaloceanspaces.com/website/All%20compressed%20assets/Vertelier%20Compressed%20Files/Mega%20compress/READY/VDNK0301/y1.webp',
      redirect: '/product-listing?subcategory=Designer&main_category=Necklace',
    },
    {
      name: 'Halo',
      main_category :'Necklace',
      image: 'https://vert-test-assets.nyc3.digitaloceanspaces.com/website/VSPL/VSPL0007/Y1.png',
      redirect: '/product-listing?subcategory=halo&main_category=Necklace',
    },
    {
      name: 'Instock',
      main_category :'Necklace',
      image: 'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/VINS/VINS/Uploads/VINS0004/r1',
      redirect: '/product-listing?subcategory=Instock&main_category=Necklace',
    },
    // {
    //   name:'Wedding Bands',
    //   main_category:'Necklace',
    //   image:'',
    //   redirect:'/product-listing?subcategory=Wedding Bands&main_category=Necklace'
    // },
    {
      name:'Special',
      main_category:'Necklace',
      image:'',
      redirect:'/product-listing?subcategory=Special&main_category=Necklace'
    }
  ];

  const pendantsCategory = [
    {
      name: 'Solitaire',
      main_category:'Pendants',
      image: '/image_category_1.svg',
      redirect: '/product-listing?subcategory=Solitaire&main_category=Pendants',
    },
    {
      name: 'Designer',
      main_category:'Pendants',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VDPD0001/w1(1).png',
      redirect: '/product-listing?subcategory=Designer&main_category=Pendants',
    },
    {
      name:'Instock',
      main_category:'Pendants',
      image: 'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/VINS/VINS/Uploads/VINS0012/r1',
      redirect:'/product-listing?subcategory=Instock&main_category=Pendants',
    },
  ];

  const braceletsCategory = [
    {
      name:'Tennis',
      main_category:'Bracelets',
      image:'https://vert-test-assets.nyc3.digitaloceanspaces.com/website/All compressed assets/Vertelier Compressed Files/Mega compress/READY/VTBR0001/y1.webp',
      redirect:'/product-listing?subcategory=Tennis&main_category=Bracelets'
    },
    {
      name:'Designer',
      main_category:'Bracelets',
      image:'https://vert-test-assets.nyc3.digitaloceanspaces.com/website/All compressed assets/Vertelier Compressed Files/Mega compress/READY/VDBR0301/y1.webp',
      redirect:'/product-listing?subcategory=Designer&main_category=Bracelets',
    },
    // {
    //   name:'Bezel',
    //   main_category:'Bracelets',
    //   image:'https://vert-test-assets.nyc3.digitaloceanspaces.com/website/VSPL/VSPL0031/W1.png',
    //   redirect:'/product-listing?subcategory=Bezel&main_category=Bracelets'
    // }
  ];

  // const defaultCategory = useMemo(() => {
  //   if (
  //     subcategory === 'Studs' ||
  //     subcategory === 'Hoops' ||
  //     subcategory === 'Three Stone'
  //   ) {
  //     return earringsCategory;
  //   } else if (
  //     subcategory === 'Tennis' ||
  //     subcategory === 'Halo' ||
  //     subcategory === 'Wedding Bands' ||
  //     subcategory === 'Special'
  //   ) {
  //     return necklaceCategory;
  //   } else if (subcategory === 'Designer' && mainCategory === 'Necklace') {
  //     return necklaceCategory;
  //   } else if (subcategory === 'Designer' && mainCategory === 'Pendants') {
  //     return pendantsCategory;
  //   } else if(subcategory === 'Instock' && mainCategory === 'Pendants'){
  //     return pendantsCategory;
  //   }else if(subcategory === 'Instock' && mainCategory === "Necklace"){
  //     return necklaceCategory
  //   }else if (subcategory === 'Designer' && mainCategory === 'Earring'){
  //     return earringsCategory
  //   } else if (subcategory === 'Solitaire' && mainCategory === 'Earring') {
  //     return earringsCategory;
  //   } else if (subcategory === 'Solitaire' && mainCategory === 'Pendants') {
  //     return pendantsCategory;
  //   }else if(subcategory === 'Instock' && mainCategory === 'Earring'){
  //     return earringsCategory
  //   }
  //   return ringsCategory;
  // }, [subcategory]);
  const defaultCategory = useMemo(() => {
  const earringSubcategories = ['Studs', 'Hoops'];
  const necklaceSubcategories = ['Special'];
  // const braceletsSubcategories = ['Bezel']

  const mapBySubcategory: Record<string, any> = {
    Designer: {
      Necklace: necklaceCategory,
      Pendants: pendantsCategory,
      Earring: earringsCategory,
      Bracelets:braceletsCategory
    },
    'Wedding Bands':{
      Necklace:necklaceCategory,
      Rings:ringsCategory
    },
    Solitaire: {
      Earring: earringsCategory,
      Pendants: pendantsCategory,
    },
    Instock: {
      Necklace: necklaceCategory,
      Pendants: pendantsCategory,
      Earring: earringsCategory,
    },
    Halo:{
      Necklace : necklaceCategory,
      Rings:ringsCategory,
    },
    'Three Stone':{
      Earring:earringsCategory,
      Rings:ringsCategory
    },
    Tennis:{
      Necklace:necklaceCategory,
      Bracelets:braceletsCategory
    },
    Bezel: {
      Bracelets:braceletsCategory,
      Rings:ringsCategory
    }
  };

  if(typeof subcategory === "string" && typeof mainCategory === 'string'){
    if (earringSubcategories.includes(subcategory)) return earringsCategory;
  if (necklaceSubcategories.includes(subcategory)) return necklaceCategory;
  // if (braceletsSubcategories.includes(subcategory)) return braceletsCategory

  if (mapBySubcategory[subcategory]?.[mainCategory]) {
    return mapBySubcategory[subcategory][mainCategory];
  }
  }

  return ringsCategory;
}, [subcategory, mainCategory]);


  const subCategoryName = useMemo(() => {
    return subcategory?.toLowerCase().trim().replaceAll(' ', '_');
  }, [subcategory]);

  const mainCategoryName = useMemo(() => {
    return mainCategory?.toLowerCase().trim().replaceAll(' ', '_');
  }, [mainCategory]);

  const mainImage = useMemo(() =>{
    return mainCategoryName
      ? `${subCategoryName}_${mainCategoryName ?? ''}`
      : subCategoryName;
  }, [subCategoryName, mainCategoryName]);

  const shapeImage = useMemo(() => {
    return shape?.toLowerCase().trim().replaceAll(' ', '_');
  }, [shape]);

  const scrollToTop = () => {
    setTimeout(() => {
      pageRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  };

  const nextPage = () => {
    setPage(page + 1);
    setSkip(skip + 16);
    // scrollToTop();
  };

  const prevPage = () => {
    setPage(page - 1);
    setSkip(skip - 16);
    // scrollToTop();
  };

  return (
    <SimpleComponent>
      <div ref={pageRef} className='w-full h-full flex-col bg-black md:bg-white'>
        {userPageLoading ? (
          <>
            <Loading
              classes={
                'flex-grow flex relative max-h-screen h-[385px] !bg-[rgba(128,128,128,0.7)] !text-white'
              }
            />
          </>
        ) : (
          <div className='w-full relative bg-black -mb-4 md:mb-0'>
            {(mainImage !== undefined || shapeImage !== undefined) &&
            !mainImage?.includes('wedding_bands') &&
            shape !== 'Baguette' ? (
              <>
                <img
                  className='w-full h-full sm:block hidden'
                  loading='lazy'
                  src={`${
                    mainImage === undefined
                      ? `https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/desktop_banner_compressed/DESKTOP_M12/${shapeImage}.webp`
                      : `https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/desktop_banner_compressed/DESKTOP_M12/${mainImage}.webp`
                  }`}
                  alt='subcategory'
                />
                {mainImage === 'designer_bracelets' ? (
                  <img
                    className='w-[430px] h-[400px] block sm:hidden'
                    src={
                      'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Banners/ddddd.png'
                    }
                    alt='subcategory'
                  />
                ) : (
                  <img
                    className='w-[430px] h-[400px] block sm:hidden'
                    src={`${
                      mainImage === undefined
                        ? `https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Banners/${shapeImage}.png`
                        : `https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Banners/${mainImage}.png`
                    }`}
                    alt='subcategory'
                  />
                )}
              </>
            ) : (
              <>
                <img
                  src='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Home_Page/prod_det_bg.webp'
                  //height={515}
                  //width={600}
                  alt='product listing'
                  className='object-cover md:hidden w-full h-[515]'
                  //loading='lazy'
                />
                <img
                  src='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Home_Page/prod_det_ng.png'
                  //height={515}
                  //width={600}
                  alt='product listing'
                  className='hidden md:block w-full h-[515px]'
                  //loading='lazy'
                />
              </>
            )}

            <div className='absolute bottom-0 md:hidden left-0 right-0 h-[60%] sm:bg-gradient-to-t sm:from-black sm:via-black/50 sm:to-transparent' />
          </div>
        )}

        {/* <div className='w-full md:px-[70px] md:pt-[80px] md:pb-[30px] rounded-b-[40px] relative bg-black z-20 hidden md:block'>
          <div className='flex flex-row w-full gap-[60px] md:gap-[20px] max-sm:gap-[0px] justify-center max-sm:justify-between'>
            {!subcategory ? (
              defaultCategory?.map((category: any, index: any) => (
                <div className='min-w-[200px] w-fit' key={index}>
                  {userPageLoading ? (
                    <div>
                      <div className='flex justify-center p-4 bg-black mt-[20px]'>
                        <div className='w-40 h-40 !bg-[rgba(128,128,128,0.3)] rounded-full border border-gray-900 animate-pulse'></div>
                      </div>
                      <Loading
                        classes={
                          'flex-grow flex relative max-h-screen justify-center mx-[30%] h-[35px] !bg-[rgba(128,128,128,0.3)] !text-white'
                        }
                      />
                    </div>
                  ) : (
                    <CategoryItems
                      image={category?.image}
                      text={category?.name}
                      onClick={() => {
                        router.push(category?.redirect)
                      }}
                      redirect={category?.redirect}
                    />
                  )}
                </div>
              ))
            ) : (
              <>
                {subcategory === 'Three Stone Rings'
                  ? threeStoneRingsCategory?.map(
                      (category: any, index: any) => (
                        <div className='min-w-[200px] w-fit' key={index}>
                          {userPageLoading ? (
                            <div>
                              <div className='flex justify-center p-4 bg-black mt-[20px]'>
                                <div className='w-40 h-40 !bg-[rgba(128,128,128,0.3)] rounded-full border border-gray-900 animate-pulse'></div>
                              </div>
                              <Loading
                                classes={
                                  'flex-grow flex relative max-h-screen justify-center mx-[30%] h-[35px] !bg-[rgba(128,128,128,0.3)] !text-white'
                                }
                              />
                            </div>
                          ) : (
                            <CategoryItems
                              image={category?.image}
                              text={category?.name}
                              onClick={() => {
                                router.push(category?.redirect)
                              }}
                              redirect={category?.redirect}
                            />
                          )}
                        </div>
                      )
                    )
                  : ''}
              </>
              // <>
              //   {userPageLoading ? (
              //     <div>
              //       <div className='flex justify-center p-4 bg-black mt-[20px]'>
              //         <div className='w-40 h-40 !bg-[rgba(128,128,128,0.3)] rounded-full border border-gray-900 animate-pulse'></div>
              //       </div>
              //       <Loading
              //         classes={
              //           'flex-grow flex relative max-h-screen justify-center mx-[30%] h-[35px] !bg-[rgba(128,128,128,0.3)] !text-white'
              //         }
              //       />
              //     </div>
              //   ) : (
              //     <CategoryItems
              //       image='/image_category_1.svg'
              //       text='CATEGORY/OPTION 1'
              //       onClick={() => {}}
              //     />
              //   )}
              //   {userPageLoading ? (
              //     <div>
              //       <div className='flex justify-center p-4 bg-black mt-[20px]'>
              //         <div className='w-40 h-40 !bg-[rgba(128,128,128,0.3)] rounded-full border border-gray-900 animate-pulse'></div>
              //       </div>
              //       <Loading
              //         classes={
              //           'flex-grow flex relative max-h-screen justify-center mx-[30%] h-[35px] !bg-[rgba(128,128,128,0.3)] !text-white'
              //         }
              //       />
              //     </div>
              //   ) : (
              //     <CategoryItems
              //       image='/image_category_2.svg'
              //       text='CATEGORY/OPTION 2'
              //       onClick={() => {}}
              //     />
              //   )}
              //   {userPageLoading ? (
              //     <div>
              //       <div className='flex justify-center p-4 bg-black mt-[20px]'>
              //         <div className='w-40 h-40 !bg-[rgba(128,128,128,0.3)] rounded-full border border-gray-900 animate-pulse'></div>
              //       </div>
              //       <Loading
              //         classes={
              //           'flex-grow flex relative max-h-screen justify-center mx-[30%] h-[35px] !bg-[rgba(128,128,128,0.3)] !text-white'
              //         }
              //       />
              //     </div>
              //   ) : (
              //     <CategoryItems
              //       image='/image_category_3.svg'
              //       text='CATEGORY/OPTION 3'
              //       onClick={() => {}}
              //     />
              //   )}
              //   {userPageLoading ? (
              //     <div>
              //       <div className='flex justify-center p-4 bg-black mt-[20px]'>
              //         <div className='w-40 h-40 !bg-[rgba(128,128,128,0.3)] rounded-full border border-gray-900 animate-pulse'></div>
              //       </div>
              //       <Loading
              //         classes={
              //           'flex-grow flex relative max-h-screen justify-center mx-[30%] h-[35px] !bg-[rgba(128,128,128,0.3)] !text-white'
              //         }
              //       />
              //     </div>
              //   ) : (
              //     <CategoryItems
              //       image='/image_category_4.svg'
              //       text='CATEGORY/OPTION 4'
              //       onClick={() => {}}
              //     />
              //   )}
              // </>
            )}
          </div>
        </div> */}

        <ScrollFade>
          <div
            className={`md:hidden gap-2 py-10 bg-black font-barlowLight text-[10px] m-0 flex overflow-x-auto [&::-webkit-scrollbar]:hidden lg:max-w-[1280px] w-screen sm:justify-center justify-start mb-0 md:mb-10 px-2 sm:px-0 ${'border-none bg-black'} px-0`}
          >
            {/* <div className='md:hidden flex gap-1 py-4 bg-black px-2 font-barlowLight text-[10px] m-0'> */}
            {defaultCategory?.map((category: any, index: any) => (
              <div
                className='flex rounded-[50%] flex-col flex-1 h-[64px] w-[64px] text-center items-center'
                key={index}
                onClick={() =>
                  router.push(
                    `/product-listing?subcategory=${encodeURIComponent(
                      category.name
                    )}&main_category=${category.main_category}`
                  )
                }
              >
                <div className='bg-[#D9D9D9] rounded-[50%] h-[64px] w-[64px] border-2 border-[#A08260] items-center justify-center'>
                  <img
                    src={category?.image}
                    alt='Image items'
                    height={175}
                    width={172}
                    className='h-[64px] w-[64px] rounded-[50%]'
                  />
                </div>
                <span className='mt-1 text-center text-[12px]'>
                  {category?.name}
                </span>
              </div>
            ))}
          </div>
        </ScrollFade>

        <div className='flex flex-col w-full md:px-[70px] bg-black md:bg-white z-10'>
          <div className='md:flex hidden justify-between'>
            <div className='flex'>
              <FilterDrawer isOpen={isOpen} setIsOpen={setIsOpen} />
              <div className='md:flex flex-row space-x-6 z-20 hidden mt-8'>
                <div className='md:hidden'>
                  <DropdownMenu
                    text='Filter'
                    items={['Option 1', 'Option 2', 'Option 3']}
                    onItemClick={handleFilterClick}
                  />
                </div>
                <DropdownMenu
                  text='Sort By'
                  items={[
                    {
                      title: 'Price: Low to High',
                      value: 'low_to_high',
                    },
                    {
                      title: 'Price: High to Low',
                      value: 'high_to_low',
                    },
                    {
                      title: 'Name: A to Z',
                      value: 'a_to_z',
                    },
                    {
                      title: 'Name: Z to A',
                      value: 'z_to_a',
                    },
                    {
                      title: 'New to Old',
                      value: 'new_to_old',
                    },
                    {
                      title: 'Old to New',
                      value: 'old_to_new',
                    },
                  ]}
                  onItemClick={handleSortByClick}
                />
              </div>
            </div>

            {products?.length && pagination?.totalPages > 1 ? (
              <div className='flex gap-[20px] items-center'>
                <span className='text-sm text-gray-700 dark:text-gray-400'>
                  Showing{' '}
                  <span className='font-semibold text-gray-900'>
                    {skip + 1}
                  </span>{' '}
                  to{' '}
                  <span className='font-semibold text-gray-900'>
                    {skip + products?.length}
                  </span>{' '}
                  of{' '}
                  <span className='font-semibold text-gray-900'>
                    {pagination?.totalItems}
                  </span>{' '}
                  Product
                </span>

                <div className='inline-flex mt-2 xs:mt-0'>
                  <button
                    onClick={prevPage}
                    disabled={skip === 0 || isLoading}
                    className={`flex items-center justify-center px-4 h-10 text-sm font-semibold border rounded-l-lg transition-colors duration-200 ${
                      skip === 0
                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        : 'bg-[#A08260] text-white hover:bg-[#8a6f4c]'
                    }`}
                  >
                    Prev
                  </button>
                  <button
                    onClick={nextPage}
                    disabled={
                      pagination?.totalItems === skip + products?.length ||
                      isLoading
                    }
                    className={`flex items-center justify-center px-4 h-10 text-sm font-semibold border rounded-r-lg transition-colors duration-200 ${
                      pagination?.totalItems === skip + products?.length
                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        : 'bg-[#A08260] text-white hover:bg-[#8a6f4c]'
                    }`}
                  >
                    Next
                  </button>
                </div>
              </div>
            ) : (
              ''
            )}
          </div>

          {/* Product desktop*/}
          <div className='hidden switch:flex flex-col w-full bg-white items-center rounded-b-[40px] z-10 md:mt-4'>
            {isLoading ? (
              <>
                <div className='w-[95%] flex flex-wrap justify-between'>
                  {[...Array(8)].map((_, index) => (
                    <Loading
                      key={index}
                      classes='max-h-screen h-[345px] w-[24%] mt-[15px] bg-[rgba(128,128,128,0.6)] !text-white rounded-none'
                    />
                  ))}
                </div>
              </>
            ) : !products || products.length === 0 ? (
              <div className='empty-state'>No products found</div>
            ) : (
              <>
                <ProductGridWithGifs
                  isRedTheme={true}
                  data={
                    products
                    // .length > 14 ? data.data.slice(0, 14) : data.data
                  }
                  page='product-listing'
                />
              </>
            )}
          </div>
          {/* mobile products */}
          <div className='md:hidden bg-black'>
            {isLoading ? (
              <>
                <div className='w-full flex flex-wrap justify-between px-2'>
                  {[...Array(6)].map((_, index) => (
                    <Loading
                      key={index}
                      classes='max-h-screen h-[280px] w-[48%] mt-[15px] bg-[rgba(128,128,128,0.6)] !text-white rounded-none'
                    />
                  ))}
                </div>
              </>
            ) : !products || products.length === 0 ? (
              <div className='empty-state text-white text-center py-8'>
                No products found
              </div>
            ) : (
              <>
                <ProductGrid data={products} />
                {products?.length && pagination?.totalPages > 1 ? (
                  <div className='flex flex-col items-center mt-1'>
                    <span className='text-sm text-[#b0b2b5]'>
                      Showing{' '}
                      <span className='font-bold text-[#FFFFFF]'>
                        {skip + 1}
                      </span>{' '}
                      to{' '}
                      <span className='font-bold text-[#FFFFFF]'>
                        {skip + products?.length}
                      </span>{' '}
                      of{' '}
                      <span className='font-bold text-[#FFFFFF]'>
                        {pagination?.totalItems}
                      </span>{' '}
                      Entries
                    </span>

                    <div className='inline-flex mt-2 xs:mt-0'>
                      <button
                        onClick={prevPage}
                        disabled={skip === 0}
                        className={`flex items-center justify-center px-4 h-10 text-sm font-semibold border rounded-l-lg transition-colors duration-200 ${
                          skip === 0
                            ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                            : 'bg-[#A08260] text-white hover:bg-[#8a6f4c]'
                        }`}
                      >
                        Prev
                      </button>
                      <button
                        onClick={nextPage}
                        disabled={
                          pagination?.totalItems === skip + products?.length
                        }
                        className={`flex items-center justify-center px-4 h-10 text-sm font-semibold border rounded-r-lg transition-colors duration-200 ${
                          pagination?.totalItems === skip + products?.length
                            ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                            : 'bg-[#A08260] text-white hover:bg-[#8a6f4c]'
                        }`}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </>
            )}
          </div>
        </div>

        {/* Sustainable Luxury */}
        <div className='flex flex-col w-full items-center z-10'>
          <SustainableLuxury
            image={
              'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Home_Page/image_sustainable_luxury2.png'
            }
            staticImageUrl={
              'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Home_Page/image_sustainable_luxury3.jpeg'
            }
            isDisplayDescription={true}
          />
        </div>
      </div>
      <Footer />
    </SimpleComponent>
  );
};

const Page: React.FC = () => {
  return (
    <Suspense>
      <ProductListingPage />
    </Suspense>
  );
};

export default Page;
